import e1_1 from "../../../../assets/images/events/e1-1.jpg";
import e1_2 from "../../../../assets/images/events/e1-2.jpg";
import e1_3 from "../../../../assets/images/events/e1-3.jpg";
import e1_4 from "../../../../assets/images/events/e1-4.webp";

import e2_1 from "../../../../assets/images/events/e2-1.jpg";
import e2_2 from "../../../../assets/images/events/e2-2.jpg";
import e2_3 from "../../../../assets/images/events/e2-3.jpg";
import e2_4 from "../../../../assets/images/events/e2-4.jpg";
import e2_5 from "../../../../assets/images/events/e2-5.jpg";
import e2_6 from "../../../../assets/images/events/e2-6.jpg";
import e2_7 from "../../../../assets/images/events/e2-7.jpg";
import e2_8 from "../../../../assets/images/events/e2-8.jpg";
import e2_9 from "../../../../assets/images/events/e2-9.jpg";

import e3_1 from "../../../../assets/images/events/e3-1.jpg";
import e3_2 from "../../../../assets/images/events/e3-2.jpg";
import e3_3 from "../../../../assets/images/events/e3-3.jpg";
import e3_4 from "../../../../assets/images/events/e3-4.jpg";
import e3_5 from "../../../../assets/images/events/e3-5.jpg";
import e3_6 from "../../../../assets/images/events/e3-6.jpg";
import e3_7 from "../../../../assets/images/events/e3-7.jpg";
import e3_8 from "../../../../assets/images/events/e3-8.jpg";
import e3_9 from "../../../../assets/images/events/e3-9.webp";
import e3_10 from "../../../../assets/images/events/e3-10.jpg";

import e4_1 from "../../../../assets/images/events/e4-1.webp";
import e5_1 from "../../../../assets/images/events/e5-1.webp";

import e6_1 from "../../../../assets/images/events/e6-1.jpg";
import e6_2 from "../../../../assets/images/events/e6-2.jpg";
import e6_3 from "../../../../assets/images/events/e6-3.jpg";
import e6_4 from "../../../../assets/images/events/e6-4.jpg";
import e6_5 from "../../../../assets/images/events/e6-5.jpg";
import e6_6 from "../../../../assets/images/events/e6-6.jpg";

import e7_1 from "../../../../assets/images/events/e7-1.jpg";
import e7_2 from "../../../../assets/images/events/e7-2.jpg";
import e7_3 from "../../../../assets/images/events/e7-3.jpg";
import e7_4 from "../../../../assets/images/events/e7-4.jpg";
import e7_5 from "../../../../assets/images/events/e7-5.jpg";
import e7_6 from "../../../../assets/images/events/e7-6.jpg";
import e7_7 from "../../../../assets/images/events/e7-7.jpg";
import e7_8 from "../../../../assets/images/events/e7-8.jpg";
import e7_9 from "../../../../assets/images/events/e7-9.jpg";
import e7_10 from "../../../../assets/images/events/e7-10.jpg";

import e8_1 from "../../../../assets/images/events/e8-1.jpg";
import e8_2 from "../../../../assets/images/events/e8-2.jpg";
import e8_3 from "../../../../assets/images/events/e8-3.jpg";
import e8_4 from "../../../../assets/images/events/e8-4.jpg";
import e8_5 from "../../../../assets/images/events/e8-5.jpg";
import e8_6 from "../../../../assets/images/events/e8-6.jpg";
import e8_7 from "../../../../assets/images/events/e8-7.jpg";
import e8_8 from "../../../../assets/images/events/e8-8.jpg";
import e8_9 from "../../../../assets/images/events/e8-9.jpg";
import e8_10 from "../../../../assets/images/events/e8-10.jpg";
import e8_11 from "../../../../assets/images/events/e8-11.jpg";
import e8_12 from "../../../../assets/images/events/e8-12.jpg";

export const events = [
  {
    id: 0,
    title: "Partenariat UIK - OMCT Tunisie",
    description:
      "Nous avons le plaisir d´annoncer la signature d'une convention de partenariat entre l'UIK - Université Ibn Khaldoun et l'OMCT Tunisie  - Organisation Mondiale Contre la Torture en Tunisie. ",
    main_img: e1_4,
    images: [e1_1, e1_2, e1_3, e1_4],
    date: "08-09-2023",
    in_home: 1,
  },
  {
    id: 1,
    title: "Cérémonie de remise des diplômes",
    description:
      "Congrats #UIKClassOf2023 ! 🎓🎉 . Et voici quelques photos de votre cérémonie de remise des diplômes, gardez-les en souvenir !",
    main_img: e2_1,
    images: [e2_1, e2_2, e2_3, e2_4, e2_5, e2_6, e2_7, e2_8, e2_9],
    date: "07-25-2023",
    in_home: 2,
  },

  {
    id: 2,
    title: "Cérémonie 2023",
    description:
      "Félicitations à tous nos diplômés, you made it #UIKClassOf2023 ! 🎓💙 Nous sommes si reconnaissants d'avoir fait partie de votre parcours vers votre futur passionnant.  Souvenez-vous de ce moment et sachez que vous serez toujours les bienvenus chez vous ! 🙌 Restez branchés pour plus de photos de la cérémonie ! 👀",
    main_img: e3_9,
    images: [e3_1, e3_2, e3_3, e3_4, e3_5, e3_6, e3_7, e3_8, e3_9, e3_10],
    date: "07-25-2023",
    in_home: 3,
  },
  {
    id: 3,
    title: "JOURNÉE PORTES OUVERTES",
    description:
      "📢 JOURNÉE PORTES OUVERTES 📢 , À vos agendas 📆 RDV MARDI 18 JUILLET , 🕝 à partir de 10H dans 📍 Campus La Soukra ! Au programme: Session d'orientation (Q&A session) / Visite du campus / Workshops pratiques en Informatique, Architecture, Design, Business et Droit !",
    main_img: e4_1,
    images: [],
    date: "07-18-2023",
    in_home: 4,
  },
  {
    id: 4,
    title: "La table ronde",
    description:
      "M. Lotfi Cherif, Président et Fondateur, représentera l'UIK à la table ronde qui aura lieu le 15 Juin à L'Académie Tunisienne Beit al-Hikma-المجمع التونسي بيت الحكمة . L'objectif de cette table ronde est de réfléchir sur la stratégie nationale à adopter face aux 𝐈𝐧𝐭𝐞𝐥𝐥𝐢𝐠𝐞𝐧𝐜𝐞𝐬 𝐀𝐫𝐭𝐢𝐟𝐢𝐜𝐢𝐞𝐥𝐥𝐞𝐬 𝐠𝐞́𝐧𝐞́𝐫𝐚𝐭𝐢𝐯𝐞𝐬 𝐭𝐞𝐥𝐥𝐞𝐬 𝐪𝐮𝐞 𝐂𝐡𝐚𝐭𝐆𝐏𝐓. 🤖",
    main_img: e5_1,
    images: [],
    date: "06-15-2023",
    in_home: 0,
  },
  {
    id: 5,
    title: "Visite de terrain",
    description:
      "𝐑𝐞𝐭𝐨𝐮𝐫 𝐞𝐧 𝐢𝐦𝐚𝐠𝐞𝐬 📸 sur la visite de nos étudiants de licence en Droit au 𝐓𝐫𝐢𝐛𝐮𝐧𝐚𝐥 𝐝𝐞 𝐏𝐫𝐞𝐦𝐢𝐞̀𝐫𝐞 𝐈𝐧𝐬𝐭𝐚𝐧𝐜𝐞 𝐝𝐞 𝐓𝐮𝐧𝐢𝐬. Nous tenons à remercier la présidente du Tribunal 👩‍⚖️ les magistrats et la greffière en chef pour leur accueil chaleureux et leur échange avec nos étudiants sur leurs expériences et leurs pratiques. Nos remerciements s'adressent aussi au Ministère de la justice et à tout responsable du Tribunal ⚖️ qui a contribué à la réussite de cette visite.",
    main_img: e6_1,
    images: [e6_1, e6_2, e6_3, e6_4, e6_5, e6_6],
    date: "05-11-2023",
    in_home: 0,
  },
  {
    id: 6,
    title: "journée Interculturelle à l'UIK",
    description:
      "Revivez l'éclat de notre 𝐉𝐨𝐮𝐫𝐧𝐞́𝐞 𝐈𝐧𝐭𝐞𝐫𝐜𝐮𝐥𝐭𝐮𝐫𝐞𝐥𝐥𝐞 à l'UIK  ! 📸✨ , 🌟 Laissez-vous transporter par ces instantanés vers les danses exaltantes, la musique envoûtante et les arômes alléchants des différentes cuisines qui nous ont unis pour célébrer nos origines et notre humanité commune. Un grand merci à tous ceux qui ont contribué au succès  notre évènement 🙌🏽. Cultivons compréhension, respect et unité dans notre communauté ! 🌍",
    main_img: e7_1,
    images: [e7_1, e7_2, e7_3, e7_4, e7_5, e7_6, e7_7, e7_8, e7_9, e7_10],
    date: "05-11-2023",
    in_home: 0,
  },
  {
    id: 7,
    title: "UIK GOT TALENTS",
    description:
      "👀 Nous savons que vous avez adoré voir les performances incroyables de nos participants, mais vous savez ce qui est encore mieux ? Les revoir en action ! 🤩🎬 Alors si vous avez été impressionnés par des talents en particulier, n'hésitez pas à les identifier dans les commentaires ! 👇 Allez, on se remet dans l'ambiance de cette soirée magique et on partage les souvenirs tous ensemble ! 🎉 ",
    main_img: e8_12,
    images: [
      e8_1,
      e8_2,
      e8_3,
      e8_7,
      e8_4,
      e8_5,
      e8_6,
      e8_8,
      e8_9,
      e8_10,
      e8_11,
      e8_12,
    ],
    date: "05-04-2023",
    in_home: 0,
  },
];
